export default __webpack_public_path__ + "static/media/empty_campaigns.adf2bf49.png";